var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.convenio.idSituacaoConvenio != 9)?_c('span',{staticClass:"text-danger float-left mr-1"},[_c('i',{staticClass:"fa fa-trash fa-lg icon-button",attrs:{"title":"Excluir Licitação"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarExcluir(_vm.licitacao.idLicitacao)}}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }